import { settingsValidation } from '@splitsoftware/splitio-commons/esm/utils/settingsValidation';
import { validateRuntime } from '@splitsoftware/splitio-commons/esm/utils/settingsValidation/runtime';
import { validateLogger } from '@splitsoftware/splitio-commons/esm/utils/settingsValidation/logger/builtinLogger';
import { validateConsent } from '@splitsoftware/splitio-commons/esm/utils/settingsValidation/consent';
import { defaults } from './defaults/browser';
import { validateStorage } from './storage/browser';
var params = {
    defaults: defaults,
    acceptKey: true,
    runtime: validateRuntime,
    storage: validateStorage,
    logger: validateLogger,
    consent: validateConsent,
};
export function settingsFactory(config) {
    return settingsValidation(config, params);
}
